import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cn-wrap pa-4" }
const _hoisted_2 = { class: "d-flex align-center mb-4" }
const _hoisted_3 = { class: "metric-row mb-4" }
const _hoisted_4 = { class: "metric-card" }
const _hoisted_5 = {
  class: "metric-icon",
  style: {"background":"#fff1ec","color":"#ff5722"}
}
const _hoisted_6 = { class: "metric-info" }
const _hoisted_7 = { class: "metric-label" }
const _hoisted_8 = { class: "metric-card" }
const _hoisted_9 = {
  class: "metric-icon",
  style: {"background":"#fdf2f8","color":"#db2777"}
}
const _hoisted_10 = { class: "metric-info" }
const _hoisted_11 = { class: "metric-label" }
const _hoisted_12 = { class: "metric-value" }
const _hoisted_13 = { class: "metric-card" }
const _hoisted_14 = {
  class: "metric-icon",
  style: {"background":"#f0fdf4","color":"#16a34a"}
}
const _hoisted_15 = { class: "metric-info" }
const _hoisted_16 = { class: "metric-label" }
const _hoisted_17 = { class: "metric-value" }
const _hoisted_18 = { class: "app-grid" }
const _hoisted_19 = { class: "card-pro" }
const _hoisted_20 = { class: "section-title" }
const _hoisted_21 = { class: "d-flex gap-2" }
const _hoisted_22 = { style: {"flex":"1"} }
const _hoisted_23 = { style: {"flex":"1"} }
const _hoisted_24 = { class: "border-top pt-3" }
const _hoisted_25 = { class: "signature-area mt-2" }
const _hoisted_26 = { class: "text-right mt-1" }
const _hoisted_27 = { class: "card-pro" }
const _hoisted_28 = { class: "section-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_DxDateRangeBox = _resolveComponent("DxDateRangeBox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_CalendarConcedii = _resolveComponent("CalendarConcedii")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        variant: "text",
        "prepend-icon": "mdi-arrow-left",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'PortalCereriConcediu' })))
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
          _createTextVNode("Înapoi la cereri", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_spacer),
      _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "text-h6 font-weight-bold" }, "Cerere nouă concediu", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode("mdi-calendar-check", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, "Zile Concediu " + _toDisplayString(_ctx.formInit.An), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["metric-value", { 'text-danger': _ctx.formInit.SoldCurent < 0 }])
          }, _toDisplayString(_ctx.formInit.SoldCurent) + " Zile", 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("mdi-history", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, "Disponibil " + _toDisplayString(_ctx.formInit.An - 1), 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formInit.SoldAn1) + " Zile", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode("mdi-archive-outline", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, "Disponibil " + _toDisplayString(_ctx.formInit.An - 2), 1),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formInit.SoldAn2) + " Zile", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("h3", _hoisted_20, [
          _createVNode(_component_v_icon, {
            color: "#ff5722",
            class: "mr-2"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("mdi-pen", -1)
            ]))]),
            _: 1
          }),
          _cache[17] || (_cache[17] = _createTextVNode("Cerere Nouă", -1))
        ]),
        _createVNode(_component_v_form, {
          modelValue: _ctx.valid,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.valid) = $event)),
          ref: "formRef",
          class: "mt-3"
        }, {
          default: _withCtx(() => [
            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "form-label-pro" }, "Interval Concediu", -1)),
            _createVNode(_component_DxDateRangeBox, {
              value: _ctx.interval,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.interval) = $event)),
              "display-format": "dd.MM.yyyy",
              "start-date-label": "De la",
              "end-date-label": "Până la",
              "start-date-placeholder": "zz.ll.aaaa",
              "end-date-placeholder": "zz.ll.aaaa",
              width: '100%',
              class: "mb-4"
            }, null, 8, ["value"]),
            _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label-pro" }, "Înlocuitor", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.form.Inlocuitor,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Inlocuitor) = $event)),
              items: _ctx.formInit.Inlocuitori,
              "item-title": "Nume",
              "item-value": "Id",
              variant: "outlined",
              density: "compact",
              clearable: "",
              class: "mb-4",
              "hide-details": "",
              placeholder: _ctx.formInit.Inlocuitori.length ? 'Selectează' : 'Niciun coleg cu cont în departament'
            }, null, 8, ["modelValue", "items", "placeholder"]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label-pro" }, "Tip", -1)),
                _createVNode(_component_v_select, {
                  modelValue: _ctx.tipSelectat,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tipSelectat) = $event)),
                  items: _ctx.formInit.TipuriConcediu,
                  "item-title": "Name",
                  "return-object": "",
                  variant: "outlined",
                  density: "compact",
                  class: "mb-4",
                  rules: [_ctx.required],
                  "hide-details": ""
                }, null, 8, ["modelValue", "items", "rules"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label-pro" }, "Fișier", -1)),
                _createVNode(_component_v_file_input, {
                  modelValue: _ctx.fisier,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fisier) = $event)),
                  variant: "outlined",
                  density: "compact",
                  "prepend-icon": "",
                  "prepend-inner-icon": "mdi-paperclip",
                  "hide-details": "",
                  class: "mb-4"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label-pro" }, "Observații", -1)),
            _createVNode(_component_v_textarea, {
              modelValue: _ctx.form.Descriere,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Descriere) = $event)),
              variant: "outlined",
              density: "compact",
              rows: "2",
              placeholder: "Detalii solicitare...",
              class: "mb-3",
              "hide-details": ""
            }, null, 8, ["modelValue"]),
            (_ctx.zilePreview > 0)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 0,
                  type: "info",
                  variant: "tonal",
                  density: "compact",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _cache[20] || (_cache[20] = _createTextVNode(" Interval selectat: ", -1)),
                    _createElementVNode("b", null, _toDisplayString(_ctx.zilePreview), 1),
                    _cache[21] || (_cache[21] = _createTextVNode(" zile lucrătoare (exclus weekend + sărbători legale) ", -1))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.error)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 1,
                  type: "error",
                  variant: "tonal",
                  density: "compact",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.error), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_24, [
              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "form-label-pro" }, "Semnătură Autorizare", -1)),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("canvas", {
                  ref: "sigCanvas",
                  class: "signature-pad",
                  onMousedown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sigStart && _ctx.sigStart(...args))),
                  onMousemove: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sigMove && _ctx.sigMove(...args))),
                  onMouseup: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.sigEnd && _ctx.sigEnd(...args))),
                  onMouseleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.sigEnd && _ctx.sigEnd(...args)))
                }, null, 544)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  size: "small",
                  color: "red",
                  onClick: _ctx.sigClear
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("Șterge semnătura", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createVNode(_component_v_btn, {
              block: "",
              color: "#ff5722",
              size: "large",
              class: "mt-3",
              loading: _ctx.loading,
              disabled: !_ctx.valid || !_ctx.interval[0] || !_ctx.interval[1],
              onClick: _ctx.submit
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { start: "" }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode("mdi-check-circle", -1)
                  ]))]),
                  _: 1
                }),
                _cache[25] || (_cache[25] = _createTextVNode("Trimite solicitarea ", -1))
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("h3", _hoisted_28, [
          _createVNode(_component_v_icon, {
            color: "#ff5722",
            class: "mr-2"
          }, {
            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
              _createTextVNode("mdi-calendar", -1)
            ]))]),
            _: 1
          }),
          _cache[30] || (_cache[30] = _createTextVNode("Vizualizare Calendar", -1))
        ]),
        _createVNode(_component_CalendarConcedii, {
          items: _ctx.myItems,
          holidays: _ctx.sarbatori,
          "initial-date": _ctx.calDate,
          mode: "year"
        }, null, 8, ["items", "holidays", "initial-date"])
      ])
    ])
  ]))
}